import { autoinject } from 'aurelia-framework';
import { DialogController, DialogService } from "aurelia-dialog";
import { WebApiService } from "../../services/web-api-service";
import 'jquery';
import 'notify';
import { SimpleDialog } from './simple-dialog';

@autoinject
export class DedicatedScacDialog {
    constructor(
        protected controller: DialogController,
        private api: WebApiService,
        private dialogService: DialogService) {
    }

    carrierId: number;
    carrierName: string;
    codes: string[] = [];
    primaryScacCode: string = "";
    scacCodeReadonly: boolean;

    activate(params) {
        this.carrierId = params[0];
        this.carrierName = params[1];
        this.codes = (params[2] || "").split(',');
        if (this.codes.length == 0) {
            this.codes.push("");
        }
        this.primaryScacCode = params[3];
        this.scacCodeReadonly = params[4];
    }

    addCode() {
        console.log(this.codes);
        let last = this.codes[this.codes.length - 1];
        if (last) {
            this.codes.push("");
        }
    }

    deleteCode(index) {
        if (this.codes.length == 1) {
            this.codes = [""];
        }
        else {
            this.codes.splice(index, 1);
        }
    }

    private changedScacs = [];
    public onScacChanged(i: number) {
        setTimeout(() => {
            const val = i == 0 ? this.primaryScacCode : this.codes[i - 1];
            if (val) {
                this.changedScacs[i] = val.toUpperCase();
            } else {
                this.changedScacs[i] = undefined;
            }
        }, 0);
    }

    cancel() {
        this.controller.cancel();
    }

    async save(close = true) {

        if (close) {
            if (this.changedScacs.find(o => o != undefined)) {
                var shouldContinue = await new Promise((resolve => {
                    this.dialogService.open({
                        viewModel: SimpleDialog,
                        model: {
                            title: "SCAC Not Published",
                            icon: "fa-exclamation-triangle",
                            message: "The follow SCAC Codes have been changed, but have not been sent to SkyBlue.\n\nUnsent Changes: " + this.changedScacs.filter(o => !!o).join(", "),
                            buttons: ["Save without sending to SkyBlue", "Cancel"]
                        }
                    }).whenClosed(result => {
                        if (!result.wasCancelled) {
                            var answer = result.output;
                            if (answer == "Save without sending to SkyBlue") {
                                resolve(true);
                            } else {
                                resolve(false);
                            }
                        }
                    })

                }));
                if (!shouldContinue) {
                    return;
                }
            }
        }

        let last = this.codes[this.codes.length - 1];
        if (!last) {
            this.deleteCode(this.codes.length - 1);
        }

        //save comments immediately; low impact because they are append-only
        for (let i = 0; i < this.codes.length; i++) {
            this.codes[i] = (this.codes[i] || "").trim() || undefined;
        }
        this.primaryScacCode = (this.primaryScacCode || "").trim() || undefined;

        var params = {
            carrierId: this.carrierId,
            primaryScacCode: this.primaryScacCode,
            codes: this.codes
        };

        await this.api.post("Carriers", "UpdateCarrierDedicatedScacCodes", params)
            .then(async () => {
                $["notify"]("Additional SCAC Codes saved", { className: "success", position: "top center" });
                if (close) await this.controller.ok();
            }, () => {
                $["notify"]("Error saving additional SCAC Codes", { className: "error", position: "top center" });
            });
    }

    async sendScacCodeToSkyBlue(i, scacCode) {

        await this.save(false);

        //save comments immediately; low impact because they are append-only
        var params = {
            carrierId: this.carrierId,
            scacCode: scacCode
        };

        await this.api.post("Carriers", "SendScacToSkyBlue", params)
            .then(async () => {
                this.changedScacs[i] = undefined;
                $["notify"]("SCAC Code sent to SkyBlue", { className: "success", position: "top center" });
            }, () => {
                $["notify"]("Error saving sending code to SkyBlue", { className: "error", position: "top center" });
            });
    }
}